import React from 'react';
import { NavLink } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFound = () => {
  return (
    <div id="page-not-found">
      <Header />
      <main>
        <section className="intro-area">
          <div className="intro-area_wrap container">
            <h1>Page Not Found</h1>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  )
}

export default NotFound;